module.exports = "#services-list .fa {\n  color: black; }\n"